import { useEffect, useState } from 'react';
import isBefore from 'date-fns/isBefore';
import { getEntriesByContentTypeAndProduct } from 'api/contentful';

const usePolicyLink = (contract) => {
  const [carrierPolicies, setCarrierPolicies] = useState([]);

  const fetchCarrierPolicies = async () => {
    const NESTING_LEVELS_TO_INCLUDE_CONTENTFUL = 5;
    const data = await getEntriesByContentTypeAndProduct(
      'policy',
      'nomad-insurance',
      NESTING_LEVELS_TO_INCLUDE_CONTENTFUL
    );
    setCarrierPolicies(data);
  };

  useEffect(() => {
    fetchCarrierPolicies();
  }, []);

  if (!contract) {
    return '/nomad-insurance/policy';
  }

  const sortedCarrierPolicies = carrierPolicies.sort(
    (a, b) => new Date(b.fields.effectiveDate) - new Date(a.fields.effectiveDate)
  );

  const firstMatchingPolicy = sortedCarrierPolicies.find(
    (policy) =>
      isBefore(
        new Date(policy.fields.effectiveDate),
        new Date(contract?.created || contract?.startDate)
      ) && contract.deductible === policy.fields.deductible
  );

  return firstMatchingPolicy
    ? `/nomad-insurance/policy?version=${firstMatchingPolicy.fields.effectiveDate}`
    : '/nomad-insurance/policy';
};

export default usePolicyLink;
